import {Component, OnInit, Input, ChangeDetectionStrategy} from '@angular/core';

import {NotificationMessage} from './notification-message.model';

@Component({
    selector: 'qnect-warning-notification',
    templateUrl: './warning-notification.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WarningNotificationComponent implements OnInit {

  @Input()
  messages: NotificationMessage[] = [];
  @Input() showPreamble: boolean = true;

  constructor() {
  }

  ngOnInit() {
  }

}
